import { Skeleton } from '@/shared/ui/Skeleton';

interface TableSkeletonProps {
  rows?: number;
}

/**
 * Esqueleto no formato da tabela.
 *
 * Reproduz a grade real para que não haja salto de layout quando os dados
 * chegam — o painel antigo trocava a tabela por um GIF centralizado, e a página
 * "pulava" a cada busca.
 */
export function TableSkeleton({ rows = 8 }: TableSkeletonProps) {
  return (
    <div aria-hidden="true" className="divide-y divide-line">
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="flex items-center gap-4 px-4 py-[1.0625rem]">
          <Skeleton className="size-8 shrink-0 rounded-full" />
          <div className="flex min-w-0 flex-1 flex-col gap-1.5">
            <Skeleton className="h-3 w-40 max-w-full" />
            <Skeleton className="h-2.5 w-56 max-w-full" />
          </div>
          <Skeleton className="hidden h-3 w-28 md:block" />
          <Skeleton className="hidden h-3 w-24 lg:block" />
          <Skeleton className="hidden h-3 w-24 lg:block" />
          <Skeleton className="hidden h-3 w-24 md:block" />
          <div className="flex shrink-0 gap-1.5">
            <Skeleton className="size-9 rounded-lg" />
            <Skeleton className="size-9 rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}
